import styled from 'styled-components';

export const TableContainer = styled.div`
	width: 100vw;
	min-width: 1400px;
	background: #fafafa;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 95px;
	padding-bottom: 11px;
`;

export const TableWrapper = styled.div`
	width: 97%;
	background: #fafafa;
	display: flex;
	padding-bottom: 11px;
	background-color: #ffffff;
	border: 1px solid #e5e5e5;
`;

export const StudentTableWrapper = styled.div`
	width: 40%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const CompanyTableWrapper = styled.div`
	width: 32%;
	display: flex;
	flex-direction: column;
`;

export const StudentManagementBoxWrapper = styled.div`
	width: 28%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 71px;
`;
